import { render, staticRenderFns } from "./MobileMain.vue?vue&type=template&id=b64ac088"
import script from "./MobileMain.vue?vue&type=script&lang=js"
export * from "./MobileMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports